var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTShirt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "la:tshirt"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 1.5C7.537 1.5 7.0275 1.635 6.5935 1.7655C6.168 1.8945 5.8555 2.0275 5.8435 2.031H5.8285L4.3905 2.516L4.3435 2.531C4.28021 2.54887 4.21781 2.56972 4.1565 2.5935L4 2.641V2.657C3.582 2.8365 2.9275 3.225 2.547 4.032C2.0295 5.125 2 6.484 2 6.484V7.5H4V14.5H12V7.5H14V6.453C14 6.453 13.957 6.0295 13.875 5.5155C13.793 5.002 13.709 4.4355 13.422 3.9845C13.075 3.43068 12.5833 2.9822 12 2.6875V2.6405L11.797 2.578C11.7675 2.5645 11.7735 2.5725 11.75 2.5625L11.656 2.531L10.172 2.031H10.156C10.1445 2.0275 9.832 1.8945 9.406 1.766C8.9725 1.635 8.4635 1.5 8 1.5ZM8 2.5C8.217 2.5 8.713 2.615 9.1095 2.7345C9.213 2.7655 9.207 2.7675 9.297 2.797C9.2655 2.8435 9.242 2.8885 9.203 2.9375C8.969 3.2285 8.6405 3.5 8 3.5C7.3595 3.5 7.031 3.2285 6.797 2.9375C6.758 2.8885 6.7345 2.8435 6.703 2.797C6.793 2.7675 6.787 2.7655 6.8905 2.7345C7.287 2.615 7.783 2.5 8 2.5ZM5.7185 3.1095C5.793 3.252 5.8885 3.4045 6.0155 3.5625C6.25382 3.8587 6.55625 4.09696 6.89999 4.25935C7.24374 4.42174 7.61985 4.50402 8 4.5C8.953 4.5 9.615 4.0215 9.9845 3.5625C10.1115 3.4045 10.207 3.252 10.281 3.1095L11 3.3595V13.5H5V3.3595L5.7185 3.1095ZM4 3.781V6.5H3C3.002 6.4725 3.078 5.2615 3.453 4.4685C3.57652 4.19828 3.76432 3.96242 4 3.7815V3.781ZM12 3.8595C12.1835 4.0135 12.3865 4.2145 12.578 4.5155C12.658 4.6425 12.8145 5.203 12.8905 5.672C12.963 6.115 12.996 6.461 13 6.5H12V3.8595Z",
    fill: "#626262"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTShirt);
export default __webpack_public_path__ + "static/media/t-shirt.feff162e069d9abde1ebd3c51519c188.svg";
export { ForwardRef as ReactComponent };